module.exports = __webpack_public_path__ + "static/media/fast.53099a66.svg";